<template>
  <div class="product-details">
    <v-card v-if="gettingData" class="common-card-log">
      <div class="d-flex flex-column align-items-center mt-8 py-6">
        <looping-rhombuses-spinner
          :animation-duration="2500"
          :rhombus-size="15"
          color="#a076f9"
          class="mx-auto my-10"
        />
      </div>
    </v-card>
    <div v-else>
      <v-card class="common-card-log">
        <div class="details_product_info">
          <v-col
            xl="3"
            lg="3"
            md="4"
            sm="4"
            xs="12"
            cols="12"
            class="align-center justify-center text-center"
          >
            <div class="my-md-12 my-2">
              <img
                class="w-100"
                :src="
                  productDetails.pictureUrl
                    ? productDetails.pictureUrl
                    : '/no-image.png'
                "
                alt=""
              />
            </div>
          </v-col>
          <v-col xl="6" lg="5" md="8" sm="8" xs="12" cols="12">
            <ProductInfo
              :product-details="productDetails"
              :authors-name="authorsName"
              :authors-id="authorsId"
              :authors="productDetails.authors ? productDetails.authors : []"
            />
          </v-col>
          <v-col
            xl="3"
            lg="4"
            md="6"
            sm="12"
            xs="12"
            cols="12"
            class="align-self-center"
          >
            <ProductSideBar
              :details="productDetails"
              :variantsStocks="variantsStocks"
            />
          </v-col>
        </div>
      </v-card>
      <v-card
        class="common-card-log mt-3"
        v-if="productDetails.aparatAuthorLink"
      >
        <v-col>
          <h2 class="font-weight-bold mt-1 fs-large">
            ویدیوی آپارات توضیحات مولف
          </h2>
        </v-col>
        <v-col>
          <div class="video-app">
            <iframe
              :src="aparatEmbedLink"
              width="640"
              height="360"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </v-col>
      </v-card>
      <v-card
        class="common-card-log mt-3"
        v-if="productDetails.aparatExpertLink"
      >
        <v-col>
          <h2 class="font-weight-bold mt-1 fs-large">
            ویدیوی آپارات توضیحات کارشناس
          </h2>
        </v-col>
        <v-col>
          <div class="video-app">
            <iframe
              :src="aparatLink"
              width="640"
              height="360"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </v-col>
      </v-card>
      <v-row class="mt-3">
        <v-col>
          <v-card class="common-card-log">
            <v-row class="d-flex align-items-center">
              <v-col>
                <h2 class="font-weight-bold mt-1 fs-large">دیدگاه کاربران</h2>
              </v-col>
              <v-col class="text-end">
                <v-btn
                  color="shopSecondary"
                  outlined
                  height="50"
                  @click="addNewComment()"
                  v-if="!newCommentMode"
                >
                  <v-icon class="me-1 question-icon">$QuestionMessage</v-icon>
                  <span class="ms-1 fs-medium">ثبت دیدگاه </span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div v-if="newCommentMode">
                  <div class="newComment-div orange lighten-5 rounded-xl pa-6">
                    <h5 class="shopSecondary--text font-weight-bold mb-5">
                      <v-icon>mdi-comment-text-outline</v-icon>
                      دیدگاه جدید
                    </h5>
                    <div class="ps-3 pe-3 pb-10">
                      <v-text-field
                        v-model="newComment.title"
                        label="عنوان دیدگاه"
                        outlined
                        color="shopSecondary"
                      ></v-text-field>
                      <v-textarea
                        v-model="newComment.text"
                        label="متن دیدگاه"
                        outlined
                        color="shopSecondary"
                        rows="3"
                      ></v-textarea>
                      <span v-if="!isUserLogin">
                        <v-icon class="me-1 shopPrimary--text"
                          >mdi-alert-circle-outline</v-icon
                        >
                        کاربر گرامی شما وارد سیستم نشده‌اید، میتوانید برای
                        افزایش مشاهده شدن دیدگاهتان در سیستم لاگین کنید.
                      </span>
                      <div class="d-flex justify-content-end">
                        <v-btn
                          class="float-end red-mainBtn me-2"
                          height="40"
                          width="130"
                          @click="
                            newCommentMode = false;
                            newComment = {};
                          "
                        >
                          <span class="fs-small"> لغو </span>
                        </v-btn>
                        <v-btn
                          class="float-end green-mainBtn"
                          height="40"
                          width="130"
                          :disabled="!newComment.title || !newComment.text"
                          @click="submitComment()"
                          :loading="newCommentLoading"
                        >
                          <span class="fs-small"> ثبت دیدگاه </span>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
                <div v-if="!comments.length">
                  <div
                    class="d-flex flex-column align-items-center justify-content-center"
                  >
                    <v-img
                      height="150"
                      width="150"
                      class="rounded-lg"
                      :src="'/comment.png'"
                    />

                    <h5 class="mt-2 text-center">
                      دیدگاهی برای این محصول به ثبت نرسیده‌ است!
                    </h5>
                  </div>
                </div>
                <div v-else>
                  <div
                    v-for="(comment, index) in comments"
                    :key="index"
                    class="grey lighten-4 rounded-xl pa-6 mt-3"
                  >
                    <div class="d-flex flex-wrap">
                      <v-col
                        xl="9"
                        lg="9"
                        md="9"
                        sm="9"
                        xs="9"
                        cols="12"
                        class="p-0"
                      >
                        <div class="d-flex flex-wrap">
                          <v-col
                            xl="12"
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            class="p-0"
                          >
                            <v-icon small>mdi-circle-medium</v-icon>
                            <span class="fs-xsmall mainFont--text">{{
                              comment.date
                            }}</span>
                          </v-col>
                          <v-col
                            xl="12"
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            class="p-0"
                          >
                            <span
                              class="fs-small font-weight-bold shopSecondary--text mr-3"
                              >{{ comment.shopCustomerName }}</span
                            >
                          </v-col>
                        </div>
                      </v-col>
                      <v-col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        cols="12"
                        class="px-0"
                      >
                        <div
                          v-if="comment.status"
                          class="float-end"
                          :class="
                            comment.status == 'رد شده'
                              ? 'red-badge'
                              : comment.status == 'در انتظار تایید'
                              ? 'orange-badge'
                              : 'green-badge'
                          "
                        >
                          {{ comment.status }}
                        </div>
                      </v-col>
                    </div>

                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="px-0 line-subject-comment"
                    >
                      <h6
                        class="fs-medium font-weight-bold shopPrimary--text my-0"
                      >
                        {{ comment.title }}
                      </h6>
                    </v-col>

                    <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
                      <span class="fs-medium font-weight-bold mainFont--text">
                        {{ comment.text }}</span
                      >
                    </v-col>
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      cols="12"
                      class="p-0"
                    >
                      <div
                        v-if="comment.adminReply"
                        style="border: 2px #ef6c00 dashed"
                        class="mt-6 rounded-lg pa-5"
                      >
                        <v-icon class="me-1 shopSecondary--text"
                          >mdi-message-question-outline
                        </v-icon>
                        <span class="fs-medium shopSecondary--text"
                          >پاسخ ادمین:</span
                        >
                        <span class="fs-medium ms-1 mainFont--text">{{
                          comment.adminReply
                        }}</span>
                      </div>
                    </v-col>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="galleryDialog" width="1000">
      <v-card class="common-card-log">
        <v-row>
          <v-col>
            <h2 class="mainFont--text">
              تصاویر محصول {{ productDetails.name }}
            </h2>
          </v-col>
          <v-col class="text-end">
            <v-icon @click="galleryDialog = false">$Close</v-icon>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <div class="w-100">
              <v-carousel
                v-model="selectedCarouselIndex"
                hide-delimiters
                :show-arrows="false"
              >
                <v-carousel-item
                  v-for="(image, index) in allImages"
                  :key="index"
                >
                  <v-img height="500" class="rounded-lg" :src="image.url" />
                </v-carousel-item>
              </v-carousel>

              <!--<v-img height="400" class="rounded-lg" :src="selectedUrl" />-->
            </div>
          </v-col>
          <v-col md="6" cols="12">
            <div class="d-flex flex-wrap">
              <div
                v-for="(image, index) in allImages"
                :key="index"
                class="ms-1 me-1 mt-3 rounded-lg"
                :style="
                  image.url == selectedUrl
                    ? 'box-shadow: rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px 0px inset;'
                    : ''
                "
              >
                <v-img
                  :src="image.url"
                  class="rounded-lg pointer"
                  width="90"
                  height="90"
                  style="opacity: 0.7"
                  @click="
                    selectedUrl = image.url;
                    selectedCarouselIndex = index;
                  "
                ></v-img>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loginDialog" width="450">
      <Login @closeLogin="closeLogin" />
    </v-dialog>
  </div>
</template>

<script>
import { HalfCircleSpinner, LoopingRhombusesSpinner } from "epic-spinners";
import Axios from "axios";
import Login from "../../../components/OnlineShop/Login";
import { mapGetters, mapMutations } from "vuex";
import ProductCounter from "../../../components/OnlineShop/ProductCounter";
import { EventBus } from "../../../event-bus";
import ProductSideBar from "@/views/OnlineShop/ProductDetails/Components/ProductSideBar";
import ProductInfo from "@/views/OnlineShop/ProductDetails/Components/ProductInfo";

export default {
  components: {
    ProductInfo,
    ProductSideBar,
    HalfCircleSpinner,
    LoopingRhombusesSpinner,
    Login,
    ProductCounter,
  },
  data() {
    return {
      pageLoading: false,

      variantsStocks: "",
      numberOfVariants: "",
      mainVariant: {},
      addLoading: [],
      shippingCosts: {},
      productDetails: {
        tags: [],
        gallery: [],
        aparatAuthorLink: "",
        aparatExpertLink: "",
      },
      publishers: [],
      relatedProducts: [],
      cart: [],
      productCount: 1,
      addToCartLoading: false,
      changeCountLoading: false,
      galleryDialog: false,
      selectedUrl: "",
      selectedCarouselIndex: 0,
      allImages: [],
      authorsName: [],
      authorsId: [],
      isUserFavourited: false,
      isLoading: false,
      gettingData: false,
      newComment: {},
      newCommentMode: false,
      newCommentLoading: false,
      isUserLogin: false,
      comments: [],
      loginDialog: false,
      reactivity: false,
      variants: [],
      metaAuthor: "",
      authors: "",
    };
  },
  metaInfo() {
    return {
      title: `${
        this.productDetails.name
          ? `${this.productDetails.name} ${this.metaAuthor} | کتاب باز`
          : "کتاب باز"
      }`, // Meta title
      meta: [
        {
          name: "description",
          content: this.productDetails.onlineShopDescription, // Meta description
        },
        {
          property: "og:title", // Open Graph meta tag
          content: this.productDetails.name,
        },
        {
          property: "og:description",
          content: this.productDetails.ogDescription,
        },
        {
          property: "og:image",
          content: this.productDetails.pictureUrl,
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "Product",
            name: this.productDetails.name,
            description: this.productDetails.description,
            Rating: this.productDetails.Rating,
            sku: this.mainId,
            additionalProperty: [
              {
                "@type": "PropertyValue",
                name: "Stock Quantity",
                value: this.productDetails.sum, // Stock quantity
              },
            ],
            brand: {
              "@type": "Brand",
              name: this.productDetails.publisherName,
            },
            Author: {
              "@type": "Person",
              name: this.authors,
            },
            offers: {
              "@type": "Offer",
              priceCurrency: "IRR", // Change if applicable
              price:
                Number(this.productDetails.specialPrice) * 10 ||
                Number(this.productDetails.price) * 10,
              availability: "https://schema.org/InStock",
              seller: {
                "@type": "Organization",
                name: "کتاب باز",
              },
            },
            image: this.productDetails.pictureUrl,
            url: `https://ketabbaaz.com/productdetails/${this.$route.params.id}`,
          },
        },
      ],
    };
  },
  beforeDestroy() {
    // Reset the meta title when leaving the page
    document.title = "کتاب باز"; // Replace with your default title
    // Optionally, remove any other meta tags
    const metaTags = document.querySelectorAll(
      "meta[data-vue-router-controlled]"
    );
    metaTags.forEach((tag) => tag.parentNode.removeChild(tag));
  },
  computed: {
    ...mapGetters(["cartItems"]),
    existInCart() {
      let result = false;
      this.cart.forEach((item) => {
        if (item.id == this.mainVariant.id) {
          this.productCount = item.amount;
          result = true;
        }
      });
      return result;
    },
    computedCarouselIndex() {
      let selectedIndex = "";
      this.productDetails.gallery.forEach((item, index) => {
        if (item.url == this.selectedUrl) {
          selectedIndex = index;
        } else {
          selectedIndex = 0;
        }
        return selectedIndex;
      });
    },
    aparatEmbedLink() {
      if (this.productDetails.aparatAuthorLink) {
        const videoId = this.productDetails.aparatAuthorLink.split("/").pop();
        return `https://www.aparat.com/video/video/embed/videohash/${videoId}/vt/frame`;
      }
      return "";
    },
    aparatLink() {
      if (this.productDetails.aparatExpertLink) {
        const videoId = this.productDetails.aparatExpertLink.split("/").pop();
        return `https://www.aparat.com/video/video/embed/videohash/${videoId}/vt/frame`;
      }
      return "";
    },
  },
  watch: {
    cartItems(val) {
      this.cart = val;
      let index = this.cart
        ? this.cart.findIndex((x) => x.id == this.mainId)
        : [];
      this.productCount = this.cart[index] ? this.cart[index].amount : 0;
    },
  },
  methods: {
    ...mapMutations(["setInCart"]),
    setInStorage() {
      this.setInCart(this.cart);
      localStorage.setItem("cart", JSON.stringify(this.cart));
    },
    goToProductDetails(item) {
      this.$router.push(item.id);
      EventBus.$emit("updateProductDetails");
    },
    isInCart(item) {
      let index = this.cart.findIndex((x) => x.id == item.id);
      if (index > -1) {
        return true;
      } else return false;
    },
    // getShippingCost() {
    //   Axios.get(this.baseUrl + "/onlineShop/options/shippingCosts", {
    //     headers: {
    //       Authorization: "Bearer: " + localStorage.getItem("shopToken"),
    //     },
    //   })
    //     .then((res) => {
    //       if (res.status == 200) {
    //         this.shippingCosts = res.data;
    //         localStorage.setItem(
    //           "shippingCost",
    //           JSON.stringify(this.shippingCosts)
    //         );
    //       }
    //     })
    //     .catch((err) => {
    //
    //     });
    // },
    removeFromFavourites() {
      Axios.patch(
        this.baseUrl + "/onlineShop/item/removeFavourite/" + this.mainId,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.getProductInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    addToFavourites() {
      Axios.patch(
        this.baseUrl + "/onlineShop/item/addFavourite/" + this.mainId,
        {
          itemId: this.mainId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            setTimeout(() => {
              this.getProductInfo();
            }, 500);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },

    closeLogin() {
      this.loginDialog = false;
      location.reload();
    },
    invokeAmount() {
      if (!localStorage.getItem("shopToken")) {
        this.loginDialog = true;
      } else {
        Axios.patch(
          this.baseUrl + "/onlineShop/item/addWaitinglist/" + this.mainId,
          {
            itemId: this.mainId,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("shopToken"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.getProductInfo();
            }
          })
          .catch((err) => {});
      }
    },
    removeUserFromWaitingList() {
      Axios.patch(
        this.baseUrl + "/onlineShop/item/removeWaitinglist/" + this.mainId,
        {
          itemId: this.mainId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.getProductInfo();
          }
        })
        .catch((err) => {});
    },
    getProductInfo() {
      this.gettingData = true;
      Axios.get(this.baseUrl + "/onlineShop/item/getData/" + this.mainId, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.productDetails = res.data.item;
            this.$router.replace({
              path: `/productdetails/${this.productDetails.name.replaceAll(
                " ",
                "-"
              )}-${this.mainId}`,
            });
            this.metaAuthor = this.productDetails.authors.length
              ? this.productDetails.authors[0].name
              : "";
            this.authors = this.productDetails.authors.length
              ? this.productDetails.authors.map((x) => x.name).join(" , ")
              : "";
            this.variantsStocks = res.data.item.sum;

            this.numberOfVariants = 1;

            this.mainVariant = this.productDetails;

            this.productDetails.authors.forEach((x) => {
              this.authorsName.push(x.name);
              this.authorsId.push(x.id);
            });
            this.isUserFavourited = this.productDetails.isUserFavourited;
            this.reactivity = !this.reactivity;

            this.allImages = this.productDetails.gallery;
            if (this.productDetails.pictureId) {
              let mainImg = {
                id: this.productDetails.pictureId,
                url: this.productDetails.pictureUrl,
              };
              this.allImages.unshift(mainImg);
            }
            if (res.data.userComments && res.data.itemComments) {
              this.comments = res.data.userComments.concat(
                res.data.itemComments
              );
            } else if (res.data.userComments) {
              this.comments = res.data.userComments;
            } else {
              this.comments = res.data.itemComments;
            }

            this.gettingData = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.gettingData = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.gettingData = false;
        });
    },
    increaseCount() {
      this.changeCountLoading = true;

      setTimeout(() => {
        this.productCount = this.productCount + 1;
        this.cart.forEach((item) => {
          if (item.id == this.mainVariant.id) {
            item.amount++;
          }
        });
        localStorage.removeItem("cart");
        localStorage.setItem("cart", JSON.stringify(this.cart));
        this.setInCart(this.cart);
        this.changeCountLoading = false;
      }, 500);
    },
    decreaseCount() {
      this.changeCountLoading = true;

      setTimeout(() => {
        this.productCount = this.productCount - 1;
        this.cart.forEach((item) => {
          if (item.id == this.mainId) {
            item.amount--;
          }
        });
        localStorage.removeItem("cart");
        localStorage.setItem("cart", JSON.stringify(this.cart));
        this.setInCart(this.cart);
        this.changeCountLoading = false;
      }, 500);
    },
    addToCartWithoutVariant() {
      this.addToCartLoading = true;
      let productObj = {
        id: this.mainVariant.id,
        parentName: this.mainVariant.parentName,
        parentId: this.mainVariant.parentId,
        amount: 1,
        price: this.mainVariant.price,
        sum: this.mainVariant.sum,
        discountedPrice: this.mainVariant.discountedPrice,
      };
      this.cart.push(productObj);
      localStorage.removeItem("cart");
      localStorage.setItem("cart", JSON.stringify(this.cart));
      this.setInCart(this.cart);
      setTimeout(() => {
        this.addToCartLoading = false;
      }, 500);
    },
    addToCart(index) {
      this.selectedVariant = this.variants[index];
      this.addToCartLoading = true;
      let productObj = {
        parentId: this.selectedVariant.parentId,
        id: this.selectedVariant.id,
        parentName: this.selectedVariant.parentName,
        amount: 1,
        price: this.selectedVariant.price,
        discountedPrice: this.selectedVariant.discountedPrice,
        sum: this.selectedVariant.sum,
        isDiscounted: this.selectedVariant.isDiscounted,
      };

      localStorage.removeItem("cart");
      localStorage.setItem("cart", JSON.stringify(this.cart));
      this.setInCart(this.cart);
      setTimeout(() => {
        this.addToCartLoading = false;
      }, 500);
    },

    addToRelatedCart(item, index) {
      this.addLoading[index] = true;
      this.reactivity = !this.reactivity;
      setTimeout(() => {
        item.amount = 1;
        this.cart.push(item);
        this.setInStorage();
        this.addLoading[index] = false;
        this.reactivity = !this.reactivity;
      }, 500);
    },
    removeFromCart() {
      this.changeCountLoading = true;
      setTimeout(() => {
        this.cart.forEach((item, index) => {
          if (item.id == this.mainVariant.id) {
            this.cart.splice(index, 1);
          }
        });
        localStorage.removeItem("cart");
        localStorage.setItem("cart", JSON.stringify(this.cart));
        this.setInCart(this.cart);
        this.changeCountLoading = false;
      }, 500);
    },
    openGalleryDialog(url) {
      this.selectedUrl = url;
      this.allImages.forEach((item, index) => {
        if (item.url == this.selectedUrl) {
          this.selectedCarouselIndex = index;
        }
      });
      this.galleryDialog = true;
    },
    addNewComment() {
      this.newComment = {};
      this.newCommentMode = true;
    },
    submitComment() {
      this.newCommentLoading = true;
      Axios.post(
        this.baseUrl + "/onlineShop/comment/new/" + this.mainId,
        {
          title: this.newComment.title,
          text: this.newComment.text,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.newCommentMode = false;
            this.newComment = { title: "", text: "" };
            this.newCommentLoading = false;
            this.getProductInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.newCommentLoading = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.newCommentLoading = false;
        });
    },
  },
  mounted() {
    this.mainId = this.$route.params.id.split("-").pop();
    EventBus.$on("updateProductDetails", () => {
      this.getProductInfo();
    }),
      // this.getShippingCost();
      window.localStorage.getItem("shopToken")
        ? (this.isUserLogin = true)
        : (this.isUserLogin = false);
    this.getProductInfo();
    this.cart = localStorage.getItem("cart")
      ? JSON.parse(localStorage.getItem("cart"))
      : [];
  },
};
</script>

<style lang="scss">
.details_product_info {
  display: flex;
  flex-wrap: wrap;
  @media only screen and (max-width: 375px) {
    flex-direction: column;
  }
}
.product-details {
  overflow: hidden;

  .price-div {
    border-radius: 10px;
    background-color: #eeeeee;
  }

  .bag-icon {
    path {
      stroke: #fff;
    }
  }

  .counterWares {
    border: 1px solid #e0e0e6;
    border-radius: 10px;
    margin-top: -3px;
    width: 110px;
    height: 42px;
  }

  .star-icon {
    width: 35px;
    height: 35px;
  }

  .extra-images {
    width: 90px;
    height: 90px;
    background-size: cover;
  }

  .question-icon {
    path {
      stroke: #1a237e;
    }
  }

  .tags {
    height: auto !important;
    min-height: 100px !important;
  }
}

.products {
  &.special-products {
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;

    .product-item {
      max-width: none;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .product-item {
    width: 100%;
    max-width: 240px;
    height: 380px;
    background-color: #fff;
    border-radius: 12px;

    .product-image {
      position: relative;

      img {
        width: 100%;
        border-radius: 12px 12px 0 0;
        aspect-ratio: 1 / 1;
      }

      .operation {
        position: absolute;
        bottom: 5px;
        right: 100px;
      }

      .add-btn {
        min-width: 0 !important;
        width: 35px;

        .v-icon {
          font-size: 1.2rem;
        }
      }
    }
  }
}

.online-table {
  .headClass {
    background-color: #ffffff;

    th {
      border: none !important;
      font-weight: normal !important;

      div {
        color: #4e536a;
      }
    }
  }

  .trClass {
    tr {
      background-color: #ffffff !important;
    }
  }

  .bodyClass {
    tr {
      border: none !important;
      height: 68px !important;

      background-color: #ffffff !important;

      td {
        border: none !important;
        text-align: center !important;
        background-color: #ffffff !important;

        div {
          padding-top: 5px;
        }

        &:nth-child(1) {
          border-top-right-radius: 8px !important;
          border-bottom-right-radius: 8px !important;
          background-color: #ffffff !important;
        }

        &:last-child {
          border-top-left-radius: 8px !important;
          border-bottom-left-radius: 8px !important;
          background-color: #ffffff !important;
        }
      }
    }
  }

  .v-pagination {
    .v-pagination__item.v-pagination__item--active {
      background-color: #f4f4ff !important;
      border: 1px solid #ef6c00 !important;
      font-size: 0.8rem !important;
      color: #ef6c00 !important;
      border-radius: 9px !important;
    }

    .v-pagination__item {
      border: none !important;
      box-shadow: none !important;
      background-color: transparent !important;
      font-size: 0.85rem !important;
      outline: none !important;
      color: #ef6c00 !important;
      font-weight: bold !important;
    }

    .v-pagination__navigation {
      border: 1px solid #ef6c00 !important;
      box-shadow: none !important;
      background-color: transparent !important;
      font-size: 12px !important;
      border-radius: 9px !important;

      path {
        stroke: #ef6c00;
      }
    }
  }

  .inner-pagination {
    svg {
      transform: translateY(-10px);
    }
  }

  .navigation-btn {
    border-radius: 9px !important;
    border: 1px solid #ef6c00 !important;
    box-shadow: none !important;
    background-color: transparent !important;
    font-size: 12px !important;
    height: 32px !important;
    width: 32px !important;
    min-width: 32px !important;
    padding: 0 !important;
    margin-top: 0.36rem;

    path {
      stroke: #ef6c00;
    }
  }

  .number-box {
    .v-text-field.v-text-field--enclosed .v-text-field__details,
    .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
      > .v-input__control
      > .v-input__slot {
      width: 70px !important;
      height: 34px !important;
      min-height: 34px !important;
      padding: 0 5px !important;

      .v-icon {
        transform: translateY(-12px);
        color: #ef6c00;
      }

      .v-select__selection--comma {
        color: #ef6c00;
      }
    }

    .v-list-item__content {
      padding: 0 !important;
    }

    .v-list-item {
      min-height: 40px !important;
    }

    .v-text-field .v-input__control,
    .v-text-field fieldset {
      border-radius: 8px !important;
      border-color: #ef6c00 !important;
    }

    .v-text-field__details {
      display: none !important;
    }

    input {
      text-align: center;
      color: #ef6c00 !important;
    }
  }
}

table {
  border-radius: 10px;
  overflow: hidden;
}

tbody tr:nth-child(even) {
  background-color: #ffffff !important;
}

table thead {
  background-color: white;
  color: black;
}

.logoPic {
  position: center !important;
  background-size: cover !important;

  img {
    height: 80px !important;
    width: auto !important;
    //  max-width:100px !important;
  }

  //  margin:0;
}

.color {
  width: 25px;
  height: 25px;
  border-radius: 50px;
}
.line-subject-comment {
  border-bottom: 1px dashed #a076f9;
}
</style>
